<template lang="pug">
#believe
  section.section.page-section.container.is-fluid
    spinner(v-if="settings.loading")
    .blocks(v-else)
      .block(
        v-for="(statement, $index) in statements"
        :key="statement.id"
        :class="{ 'is-even': $index % 2 === 0, 'is-odd': $index % 2 !== 0 }"
      )
        .block-image
          cl-img(
            v-if="statement._embedded.image.id"
            :cl-id="statement._embedded.image.cl_id"
            :transform="{ width: 640, height: 360 }"
          )
        .block-details
          .content.mobile-padding
            h3.is-size-2-desktop.is-size-3-touch {{ statement.heading }}
            p.is-size-5 {{ statement.body }}
            .level.has-text-grey.is-mobile(v-if="statement.scriptures && statement.scriptures.length > 0")
              .level-left
                .level-item(
                  v-for="(scripture, $scripture_index) in statement.scriptures"
                  :key="$scripture_index"
                ) {{ scripture }}
//- section#belief.section.page-section.top-section
//-   //- .dark-header.centered
//-   //-   .container.is-fluid.mobile-padding
//-   //-     h4.is-size-2.has-text-weight-semibold {{ page.h1 }}
//-   //-     h4.is-size-4 {{ page.h2 }}
//-   section.section.page-section
//-     .container.is-fluid.mobile-padding
//-       .columns
//-         .column.is-two-thirds
//-           .content
//-             span(v-html="$options.filters.markdown(page.body)")
//-         .column.is-one-third
//-           //- h4.is-size-5.has-text-weight-semibold Popular Sermon Topics
//-           //- episode-tags
//-           //- h4.is-size-5.has-text-weight-semibold(style="margin-top:2rem;") Our Senior Pastor
//-           //- p Pastor Mike Webb was born and raised in Birmingham, Alabama. He attended the University of Alabama, where he majored in Business Administration. Following college, he attended Rhema Bible Training Center in Tulsa, Oklahoma for ministerial training. After seminary, he worked as an associate minister and traveled with the Kenneth E. Hagin crusade team. He and his wife Beth worked as itinerant ministers and missionaries for a year and half before founding Foothill Family Church in Orange County, California, in 1986.
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'believe',
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      statements: getterTypes.GET_BELIEF_STATEMENTS,
    }),
  },
  created() {
    if (this.statements.length === 0) {
      this.getStatements();
    }
  },
  data() {
    return {
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async getStatements() {
      this.settings.loading = true;
      await this.$store.dispatch(actionTypes.DO_GET_BELIEF_STATEMENTS, {
        zoom: 'image',
      });
      this.settings.loading = false;
    },
  },
};
</script>

<style lang="scss">
#believe {
  @include blocks;
  .header {
    @include hero;
  }
  .block {
    .block-details {
      .level {
        .level-left {
          flex-flow: wrap;
          flex-shrink: inherit;
          justify-content: flex-start;
          .level-item {
            flex-grow: 0;
            margin-bottom: 0.5rem;
          }
        }
      }
    }
  }
}

@media (max-width: $tablet) {
  #believe {
    .page-section {
      padding-top: 0;
    }
  }
}
// #belief {
//   .dark-header {
//     background-image: url('/static/images/church-header.jpg');
//     background-size: cover;
//     background-position: left;
//   }
// }
</style>
